import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { rowOwner, ownerDisplayName } from '../../lib/noShowList';

// «Ubekreftede timer» on Alle besøk: past bookings that never became a sale.
// Rows come from calendarEventStore.loadUnconfirmedBookings(); the parent
// (allVisits.js) owns the date range and search text.
@observer
class DyrejournalUnconfirmedBookings extends Component {
    openEvent = (e) => {
        e.stopPropagation();
        const { drawerLevel = 2, callback = () => {} } = this.props;
        const { appState } = this.props.stores;
        const id = parseInt(e.currentTarget.dataset.id, 10);
        if (!id) {
            return;
        }
        appState.openDrawer('viewCalendarEvent', {
            height: appState.drawerHeightLarge,
            id,
            showEdit: true,
            callback,
        }, drawerLevel + 1);
    }

    statusIcon(row) {
        if (row.doneTime) {
            return <i class='fa-duotone fa-check-circle text-success me-1' title='Ferdig' />;
        }
        if (row.receivedTime) {
            return <i class='fa-duotone fa-user-doctor text-primary me-1' title='Mottatt av veterinær' />;
        }
        if (row.arrivedTime || row.hasArrived) {
            return <i class='fa-solid fa-hourglass-clock text-warning me-1' title='Ankommet' />;
        }
        return <i class='fa-regular fa-circle text-body-secondary me-1' title='Ikke åpnet' />;
    }

    render() {
        const { loading } = this.props;
        const { calendarEventStore } = this.props.stores;
        const { unconfirmedBookings = [], unconfirmedBookingsTotal = 0 } = calendarEventStore;

        return (<>
            <div class='alert alert-secondary mt-2' role='alert'>
                <i class='fa-duotone fa-calendar-circle-exclamation me-2' />
                <Text id='dyrejournal.unconfirmed.intro'>Showing past bookings that have no sale. A booking disappears from this list when a sale is created from it, when one of its animals gets a sale the same day, when it is marked as done, or when it is marked as no-show. Vaccine recalls are not shown.</Text>
                {unconfirmedBookingsTotal > 0 && <span class='ms-2 badge text-bg-warning rounded-pill'>{unconfirmedBookingsTotal}</span>}
            </div>
            <div class='table-responsive'>
                <table class='table table-striped table-hover table-sm'>
                    <thead>
                        <tr>
                            <th><Text id='dyrejournal.unconfirmed.col-date'>Date</Text></th>
                            <th><Text id='dyrejournal.unconfirmed.col-time'>Time</Text></th>
                            <th><Text id='dyrejournal.unconfirmed.col-status'>Status</Text></th>
                            <th><Text id='dyrejournal.unconfirmed.col-animal'>Animal</Text></th>
                            <th><Text id='dyrejournal.unconfirmed.col-owner'>Owner</Text></th>
                            <th><Text id='dyrejournal.unconfirmed.col-booking'>Booking</Text></th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {unconfirmedBookings.map(row => {
                            const owner = rowOwner(row);
                            const ownerName = ownerDisplayName(owner);
                            const animalNames = (row.animals || []).map(a => a.name).filter(Boolean).join(', ');
                            return (
                                <tr key={row.id} data-id={row.id} onClick={this.openEvent} style='cursor: pointer;'>
                                    <td><nobr>{row.start ? util.isoDate(row.start, false, false, true) : ''}</nobr></td>
                                    <td><nobr>{row.start ? util.isoTime(row.start) : ''}</nobr></td>
                                    <td>{this.statusIcon(row)}</td>
                                    <td>{animalNames}</td>
                                    <td>
                                        {ownerName || <Text id='dyrejournal.unconfirmed.unknown-owner'>Unknown owner</Text>}
                                        {owner && owner.cellphone && <small class='ms-2 text-body-secondary'>{owner.cellphone}</small>}
                                    </td>
                                    <td class='text-wrap'>
                                        <small class='text-body-secondary me-1'>{row.calendarId}</small>
                                        {row.title}
                                        {row.body && <small class='ms-1 text-body-secondary'>{row.body}</small>}
                                    </td>
                                    <td class='text-end'>
                                        <button type='button' class='btn btn-sm btn-outline-primary rounded-pill' data-id={row.id} onClick={this.openEvent}>
                                            <i class='fa-duotone fa-calendar-day me-1' />
                                            <Text id='dyrejournal.unconfirmed.open-booking'>Open booking</Text>
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {loading && <div class='text-center py-3'><i class='fa-solid fa-spinner fa-spin' /></div>}
                {!loading && unconfirmedBookings.length === 0 && <div class='alert alert-success'>
                    <i class='fa-duotone fa-circle-check me-2' />
                    <Text id='dyrejournal.unconfirmed.empty'>No unconfirmed bookings in this period</Text>
                </div>}
            </div>
        </>);
    }
}

export default DyrejournalUnconfirmedBookings;
